module.exports = __webpack_public_path__ + "6ba41b84c580749ba32ef34e2f0f3075.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/Konsumentenpreis.svg
// module id = 257
// module chunks = 1